import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faChartLine, faDollarSign, faUsers } from '@fortawesome/free-solid-svg-icons';
import './FadeIn.css';
import { Helmet } from 'react-helmet';
import '@fontsource/oswald';

function ContactUs() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [submissionMessage, setSubmissionMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (event.target['Country'].value) return;

        setIsSubmitted(false);
        setSubmissionMessage('');

        const formData = {
            firstName: event.target['grid-first-name'].value,
            lastName: event.target['grid-last-name'].value,
            email: event.target['grid-email'].value,
            phone: event.target['grid-phone'].value,
            additionalInfo: event.target['grid-additional-info'].value
        };

        setIsSubmitting(true);

        try {
            const response = await fetch('https://iq9246yne3.execute-api.us-west-1.amazonaws.com/prod/contactEmail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            setIsSubmitted(true);
            setSubmissionMessage('Your message has been submitted! A member of our team will be in touch shortly.');
        } catch (error) {
            setSubmissionMessage('An error occurred while sending your request.');
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: "'oswald', sans-serif" }}>
            <Header />
            <div style={{ flexGrow: 1, fontFamily: "'oswald', sans-serif",backgroundColor: '#f3f4f6', padding: '1rem 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="flex flex-wrap max-w-7xl w-full px-4 mt-10">
                    {/* Left: Form */}
                    <div className="w-full lg:w-1/2">
                        <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', padding: '1rem', animation: 'fadeInUp 0.5s ease-out both' }}>
                            <span style={{ fontSize: '2rem', fontFamily: 'oswald',fontWeight: 'bold', color: '#1a202c', textAlign: 'center', display: 'block' }}>Contact Us</span>
                            <form onSubmit={handleSubmit}>
                                {/* First Name */}
                                <div style={{ marginBottom: '1.5rem', marginTop: '1rem' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#4a5568', marginBottom: '0.5rem' }} htmlFor="grid-first-name">
                                        First Name <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <input style={{ width: '100%', padding: '0.5rem 1rem', borderRadius: '4px', border: '1px solid #cbd5e0', backgroundColor: '#edf2f7', color: '#2d3748' }} id="grid-first-name" type="text" placeholder="John" required />
                                </div>
                                {/* Last Name */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#4a5568', marginBottom: '0.5rem' }} htmlFor="grid-last-name">
                                        Last Name <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <input style={{ width: '100%', padding: '0.5rem 1rem', borderRadius: '4px', border: '1px solid #cbd5e0', backgroundColor: '#edf2f7', color: '#2d3748' }} id="grid-last-name" type="text" placeholder="Doe" required />
                                </div>
                                {/* Email */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#4a5568', marginBottom: '0.5rem' }} htmlFor="grid-email">
                                        Email <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <input style={{ width: '100%', padding: '0.5rem 1rem', borderRadius: '4px', border: '1px solid #cbd5e0', backgroundColor: '#edf2f7', color: '#2d3748' }} id="grid-email" type="email" placeholder="email@example.com" required />
                                </div>
                                {/* Phone Number */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#4a5568', marginBottom: '0.5rem' }} htmlFor="grid-phone">
                                        Phone Number <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <input style={{ width: '100%', padding: '0.5rem 1rem', borderRadius: '4px', border: '1px solid #cbd5e0', backgroundColor: '#edf2f7', color: '#2d3748' }} id="grid-phone" type="tel" placeholder="123-456-7890" required />
                                </div>
                                {/* Additional Info */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#4a5568', marginBottom: '0.5rem' }} htmlFor="grid-additional-info">
                                        Message <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <textarea style={{ width: '100%', padding: '0.5rem 1rem', borderRadius: '4px', border: '1px solid #cbd5e0', backgroundColor: '#edf2f7', color: '#2d3748' }} id="grid-additional-info" rows="3" placeholder="How can we assist you with our services?" required></textarea>
                                </div>
                                {/* Honeypot */}
                                <div style={{ display: "none" }}>
                                    <input type="text" name="Country" />
                                </div>
                                {/* Submit */}
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        onMouseEnter={(e) => {
                                            if (!isSubmitting) e.target.style.backgroundColor = '#2b6cb0';
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSubmitting) e.target.style.backgroundColor = '#3182ce';
                                        }}
                                        style={{
                                            width: '100%',
                                            padding: '0.75rem 1.5rem',
                                            backgroundColor: '#3182ce',
                                            color: '#fff',
                                            fontWeight: '600',
                                            borderRadius: '4px',
                                            cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                            transition: 'background-color 0.3s ease',
                                        }}
                                    >
                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                    </button>
                                </div>
                                {submissionMessage && (
                                    <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                                        <p style={{ color: isSubmitted ? '#38a169' : '#e53e3e' }}>{submissionMessage}</p>
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>

                    {/* Right: Info Section */}
                    <div className="w-full lg:w-1/2 mt-10 lg:mt-0 lg:pl-12 space-y-8 ">
                        <div className="flex items-start gap-4">
                            <FontAwesomeIcon icon={faUsers} size="2x" className="text-[#b42520]" />
                            <div>
                                <h3 className="font-bold text-lg">Understanding Your Needs</h3>
                                <p>At Jackpot Concierge, we're excited to learn about your Las Vegas trip and how we can make it the best possible.</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <FontAwesomeIcon icon={faChartLine} size="2x" className="text-[#b42520]" />
                            <div>
                                <h3 className="font-bold text-lg">Constantly Improving</h3>
                                <p>Our application continuously evolves, integrating user feedback to enhance your experience and streamline our operations.</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <FontAwesomeIcon icon={faDollarSign} size="2x" className="text-[#b42520]" />
                            <div>
                                <h3 className="font-bold text-lg">More Value for Your Money</h3>
                                <p>Jackpot Concierge offers competitive pricing while delivering a one-of-a-kind experience unlike any of our competitors.</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <FontAwesomeIcon icon={faBullhorn} size="2x" className="text-[#b42520]" />
                            <div>
                                <h3 className="font-bold text-lg">Your Voice Matters</h3>
                                <p>Your feedback is a vital part of our development process. Help us shape the future of Jackpot Concierge to better serve Las Vegas visitors like you.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;